<script setup lang="ts">
import OpenModalButton from '../OpenModalButton.vue'

interface Props {
  disabled: boolean
}

defineProps<Props>()
</script>

<template>
  <OpenModalButton
    icon="tshirt"
    title="Skins"
    :disabled
  />
</template>
